module.exports = __webpack_public_path__ + "static/media/29EUNOG9.2bcad820.jpg";